import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "mb-20" }, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, "我负责的", -1)
const _hoisted_3 = {
  key: 1,
  style: {"min-height":"700px"}
}


const __default__ = {
    name:"TicketList"
}
import {ref, reactive, computed, onBeforeMount, nextTick, onMounted,shallowRef, onBeforeUnmount} from 'vue'
import {ElMessage, ElMessageBox, genFileId} from 'element-plus'
import store from "@/store/index";
import { exportHandle } from '@/utils/index'
import "@wangeditor/editor/dist/css/style.css";
import { Editor, Toolbar } from "@wangeditor/editor-for-vue";
import TicketTable from "./TicketTable.vue"
import Api from '@/http/modules/index'
import { useRoute,useRouter} from 'vue-router'

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const {
    'POST/tickets/list':getTicketsApi,
    // 用户下拉列表
    'POST/tickets/users': usersListApi,
     // 项目列表
    'GET/tickets/projects':ticketsProjectsApi,
    // 语言列表
    'GET/languages':languagesApi,
    // 判断接口人
   'GET/tickets/user/role':ticketUserRoleApi,

} = Api
const route=useRoute()
const router=useRouter()
const activeName=ref<any>("Submit")
const projectLists=ref([])
const userList=ref([])
const assignedToList=ref([])
const languageLists=ref([])
const showAll=ref(false)
const checking=ref(false)
const getTickets=(isSearch:boolean=false)=>{
   
    let params:any={
        page:1,size:30,
        startTime:"",
        endTime:""
    }
    
    getTicketsApi(params).then((res:any)=>{
        showAll.value=res.rowCount>0?true:false
        checking.value=true
    }).catch(()=>{
        checking.value=true
    })
}
const responsibleTotal=ref(0)
const tagChange=()=>{
    router.push({query:{tag:activeName.value}})
}
onBeforeMount(()=>{
    ticketUserRoleApi().then((res:any)=>{
        activeName.value=route.query.tag?route.query.tag:res.isUser?'Responsible':'Submit'
        router.replace({query:{tag:activeName.value}})
    })
})
onMounted(()=>{    
    getTickets()
    usersListApi().then((res:any)=>{
        userList.value=res.userList
        assignedToList.value=res.assignedToList
    })
    ticketsProjectsApi().then((res:any)=>{
        projectLists.value=res
    })
    languagesApi().then((res:any)=>{
        languageLists.value=res
    })
})

return (_ctx: any,_cache: any) => {
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_badge = _resolveComponent("el-badge")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    (checking.value)
      ? (_openBlock(), _createBlock(_component_el_tabs, {
          key: 0,
          onTabChange: tagChange,
          style: {"width":"100%"},
          class: "ticket-tab",
          modelValue: activeName.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((activeName).value = $event))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_tab_pane, {
              label: "我提交的",
              name: "Submit"
            }, {
              default: _withCtx(() => [
                _createVNode(TicketTable, {
                  langs: languageLists.value,
                  projects: projectLists.value,
                  assignedToList: assignedToList.value,
                  users: userList.value,
                  listType: 'Submit'
                }, null, 8, ["langs", "projects", "assignedToList", "users"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_tab_pane, {
              label: "我负责的",
              name: "Responsible"
            }, {
              label: _withCtx(() => [
                _hoisted_2,
                _createVNode(_component_el_badge, { value: responsibleTotal.value }, null, 8, ["value"])
              ]),
              default: _withCtx(() => [
                _createVNode(TicketTable, {
                  langs: languageLists.value,
                  projects: projectLists.value,
                  assignedToList: assignedToList.value,
                  users: userList.value,
                  listType: 'Responsible',
                  onSetTotal: _cache[0] || (_cache[0] = (val)=>responsibleTotal.value=val)
                }, null, 8, ["langs", "projects", "assignedToList", "users"])
              ]),
              _: 1
            }),
            (showAll.value)
              ? (_openBlock(), _createBlock(_component_el_tab_pane, {
                  key: 0,
                  label: "全部工单",
                  name: "All"
                }, {
                  default: _withCtx(() => [
                    _createVNode(TicketTable, {
                      langs: languageLists.value,
                      projects: projectLists.value,
                      assignedToList: assignedToList.value,
                      users: userList.value,
                      listType: 'All'
                    }, null, 8, ["langs", "projects", "assignedToList", "users"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, null, 512)), [
          [_directive_loading, !checking.value]
        ])
  ], 64))
}
}

})